import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

function CircularProgressWithLabel(props) {
  const grade =
    props.value >= 90
      ? '#00e676'
      : props.value >= 75
      ? '#0091ea'
      : props.value >= 50
      ? '#ffeb3b'
      : props.value >= 40
      ? '#ff7043'
      : '#d32f2f';
  return (
    <Box position='relative' display='inline-flex'>
      <CircularProgress
        variant='determinate'
        style={{ color: grade }}
        {...props}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position='absolute'
        display='flex'
        alignItems='center'
        justifyContent='center'
      >
        <Typography
          variant='caption'
          component='div'
          color='textSecondary'
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

export default function StaticProgress({ progress }) {
  // const [progress, setProgress] = React.useState(10);

  // React.useEffect(() => {
  //   const timer = setInterval(() => {
  //     setProgress((prevProgress) =>
  //       prevProgress >= 100 ? 0 : prevProgress + 10
  //     );
  //   }, 800);
  //   return () => {
  //     timer;
  //   };
  // }, []);

  return <CircularProgressWithLabel value={progress || 0} />;
}
